var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container"},[_c('div',{staticClass:"pdf-content"},[_c('div',{staticClass:"pdf-pages"},_vm._l((_vm.pageCount),function(page){return _c('div',{key:page,staticClass:"pdf-page"},[_c('pdf',{attrs:{"src":_vm.pdfSrc,"page":page}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }